import { getEnumValues } from '../enums/get-enum-values';

export enum TeamPermission{
	InviteAthlete='inviteAthlete',
}

export const TeamPermissionValues = getEnumValues<TeamPermission>(TeamPermission);